export default {
	attributes: {
		design: 'side-title-1',
		columns: 1,
		reverseTitle: false,
		alignment: 'center',
		showColumnRule: false,
		showTitle: true,
		title: 'Block Title',
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		showSubtitle: false,
		subtitleLineHeightUnit: 'em',
		subtitleTabletLineHeightUnit: 'em',
		subtitleMobileLineHeightUnit: 'em',
		subtitleOnTop: false,
		text1: 'Description for this block. Use this space for describing your block. Any text will do. Description for this block.',
		textLineHeightUnit: 'em',
		textTabletLineHeightUnit: 'em',
		textMobileLineHeightUnit: 'em',
		uniqueClass: 'ugb-286b500',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
	},
}
